import React, { useEffect } from "react";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import stripeService from "../services/stripeService";

export default function Payments(purchaseDetails) {
  const { session } = useContext(AuthContext);

  useEffect(() => {
    const initiateCheckout = async () => {
      try {
        await stripeService.createCheckoutSession(session, purchaseDetails);
      } catch (error) {
        console.error("Failed to initiate checkout:", error);
        // Add an error message or redirect
      }
    };

    if (session) {
      initiateCheckout();
    }
  }, [session]);

  // Show a loading state while redirecting to Stripe
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          Redirecting to checkout...
        </h2>
        <p className="text-gray-500">
          Please wait while we prepare your payment.
        </p>
      </div>
    </div>
  );
}
